<template>
  <div class="container p-32 mx-auto">
    <h1 class="mb-16">ApplePay</h1>
    <div class="mb-24 text-blue">showApplePayButton: {{ showApplePayButton }}</div>
    <div class="mb-16 p-8 border border-grey-lighter bg-white">
      <li>showApplePayButton: {{ showApplePayButton }}</li>
      <li>result: {{ result }}</li>
      <li>applepay_token: {{ applepay_token }}</li>
    </div>
    <button class="btn btn-solid btn-blue" @click="applePayTest">測試 Apple Pay</button>
  </div>
</template>

<script>
import OwlTingApplePay from '@/utils/applepay.js'
/* eslint-disable*/
const applePayUrl = process.env.NODE_ENV === 'production' ? 'validate_owj' : 'validate_owj_stage'
const applepay  = new OwlTingApplePay('applePayButton', `https://www.owlting.com/business/ap/${applePayUrl}.php?u=`)
let applepay_token
/* eslint-enable */
export default {
  name: 'ApplePay',
  data () {
    return {
      showApplePayButton: false,
      result: null,
      applepay_token: null
    }
  },
  methods: {
    applePayTest: function () {
      /* eslint-disable*/
      this.applepay_token = applepay_token
      const data = {
        currency: 'TWD',
        country: 'TW',
        name: 'Phantas Test Prod',
        totalPrice: '10'
      }
      const result = applepay.sendIfTokenValid(applepay_token, data.currency, data.country, data.name, data.totalPrice)
      console.debug('[APPLE PAY] token', applepay_token)
      console.debug('[APPLE PAY] result', result)
      this.result = result
      /* eslint-enable */
    }
  },
  mounted () {
    /* eslint-disable*/
    const that = this
    if (applepay.isCanMakePayment()) {
      this.showApplePayButton = true
    }
    applepay.event_SendApplepay = function(token) {
      console.debug('[APPLE PAY] send apple pay token with cart', token)
      if (1) {
        //payment success
        applepay.completePaymentSessionSuccess()
      } else {
        //payment failed
        applepay.completePaymentSessionFail()
      }
    }
    applepay.event_CancelApplepay = function() {
      console.debug('[APPLE PAY] apple pay action is cancelled')
    }
    /* eslint-enable */
  }
}
</script>

<style lang="sass">

</style>
